<div class="alert-container alert-component-container" [ngClass]="alertType">
    <div *ngIf="showIcon">
        <mat-icon>{{ iconsByAlertType[alertType] }}</mat-icon>
    </div>
    <div>
        <p><ng-content></ng-content></p>
    </div>
</div>
